
/*import React from 'react';
import './BlogFullVersion.scss';
import { Link, } from 'react-router-dom';
import imageUrlBuilder from "@sanity/image-url";
import { useState, useEffect } from 'react';
import blogBack from "../../assets/img/blog-back.png";
import BlockContent from '@sanity/block-content-to-react';
import { useMatch, useParams } from 'react-router-dom';
import { whitelists } from '../../i18n';


function BlogFullVersion({ t }) {

  const { id } = useParams();
  const [postData, setPostData] = useState(null);
  const builder = imageUrlBuilder({
    projectId: "2tnperol",
    dataset: "production",
  });

  const match = useMatch('/:lang/*');
  let lang = match && match.params ? (whitelists.includes(match.params.lang) ? match.params.lang : null) : null;
  const backLink = lang ? `/${lang}/blog` : `/blog`;


  useEffect(() => {
    const PROJECT_ID = "2tnperol";
    const DATASET = "production";
    const QUERY = encodeURIComponent(
      `*[_type == "post" && _id == "${id}"]{_id, title,_updatedAt, mainImage, author->, body[], "image": image{...,"asset": asset->,}}`
    );

    const PROJECT_URL = `https://${PROJECT_ID}.api.sanity.io/v2021-10-21/data/query/${DATASET}?query=${QUERY}`;

    fetch(PROJECT_URL)
      .then((res) => res.json())
      .then(({ result }) => {
        if (result.length > 0) {
          setPostData(result[0]);

        }
      })
      .catch((err) => console.error(err));
  }, [id]);

  function formatDate(dateStr) {
    const inputDate = new Date(dateStr);
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    const month = monthNames[inputDate.getMonth()];
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    return `${month} ${day}, ${year}`;
  }



  const serializers = {
    types: {
      code: (props) => (
        <pre data-language={props.node.language}>
          <code>{props.node.code}</code>
        </pre>
      ),
      image: (props) => {
        if (props.node.asset) {
          return (
            <img
              className="custom-image-style"
              src={builder.image(props.node.asset).auto('format').url()}
              alt={props.node.alt}
            />
          );
        } else {
          return null;
        }
      },
    },
  };

  let b = null;

  if (postData) {
    b = postData.body.find((i) => i._type === lang && lang !== null);

    if (!b) {
      b = postData.body.find((i) => i._type === 'ru');
    }
  }


  return (
    <div className="blogFull-content-wrapper">
      {postData && (
        <>
          <div className="blog-full-top">
            <div className="blog-full-top-content">
              <div className="blog-full-capture">
                {postData.title[lang]}
              </div>
            </div>
          </div>
          <div className="blog-full-body-content">
            <div className="blog-full-nav">
              <Link to={backLink}>
                <div className="button-back">
                  <div className='blog-arrow-position'><img src={blogBack} alt="back" /></div>
                  <div>{t("blog_full_back_button")}</div>
                </div>
              </Link>
              <div className="date-of-creation">
                {formatDate(postData._updatedAt)}
              </div>
            </div>
            <div className="blog-full-body-content-position">
              {b && (
                <BlockContent blocks={b.content} serializers={serializers} />
              )}

            </div>
            <div className="body-full-author">
              {/* {postData.author && (
                <div className='body-full-author-position'>                         if author needed
                  <div>{postData.author.name}</div>
                  {postData.author.image && (
                    <img
                      src={builder.image(postData.author.image.asset._ref).url()}
                      alt={'image3'}
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  )}
                </div>
                  )}*//*}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default BlogFullVersion;*/
import React from 'react';
import './BlogFullVersion.scss';
import { Link } from 'react-router-dom';
import imageUrlBuilder from "@sanity/image-url";
import { useState, useEffect } from 'react';
import blogBack from "../../assets/img/blog-back.png";
import BlockContent from '@sanity/block-content-to-react';
import { useMatch, useParams } from 'react-router-dom';
import { whitelists } from '../../i18n';
import OtherArticles from './OtherArticles';

function BlogFullVersion(props) {

  const { id } = useParams();
  const [postData, setPostData] = useState(null);
  const builder = imageUrlBuilder({
    projectId: "2tnperol",
    dataset: "production",
  });

  const match = useMatch('/:lang/*');
  let lang = match && match.params ? (whitelists.includes(match.params.lang) ? match.params.lang : null) : null;
  const backLink = lang ? `/${lang}/blog` : `/blog`;
  const[currentPageId,setCurrentPageId] = useState('');

  useEffect(() => {
    const PROJECT_ID = "2tnperol";
    const DATASET = "production";
    const QUERY = encodeURIComponent(
      `*[_type == "post" && _id == "${id}"]{_id, title,_updatedAt, mainImage, author->, body[], "image": image{...,"asset": asset->,}}`
    );

    const PROJECT_URL = `https://${PROJECT_ID}.api.sanity.io/v2021-10-21/data/query/${DATASET}?query=${QUERY}`;

    fetch(PROJECT_URL)
      .then((res) => res.json())
      .then(({ result }) => {
        if (result.length > 0) {
         // console.log('result - ' + JSON.stringify(result[0]))
          setPostData(result[0]);
          setCurrentPageId(result[0]._id)
        }
      })
      .catch((err) => console.error(err));
  }, [id]);

  function formatDate(dateStr) {
    const inputDate = new Date(dateStr);
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    const month = monthNames[inputDate.getMonth()];
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  const serializers = {
    types: {
      code: (props) => (
        <pre data-language={props.node.language}>
          <code>{props.node.code}</code>
        </pre>
      ),
      image: (props) => {
        if (props.node.asset) {
          return (
            <img
              className="custom-image-style"
              src={builder.image(props.node.asset).auto('format').url()}
              alt={props.node.alt}
            />
          );
        } else {
          return null;
        }
      },
    },
  };
  
  let b = null;

  if (postData && postData.body) {
    b = postData.body.find((i) => i._type === lang && lang !== null);

    if (!b) {
      b = postData.body.find((i) => i._type === 'ru');
    }
  }

  return (
    <div className="blogFull-content-wrapper">
      {postData && (
        <>
          <div className="blog-full-top">
            <div className="blog-full-top-content">
              <div className="blog-full-capture">
                {postData.title ? (lang == null ? postData.title.ru : postData.title[lang]) : ""}
              </div>
            </div>
          </div>
          <div className="blog-full-body-content">
            <div className="blog-full-nav">
              <Link to={backLink}>
                <div className="button-back">
                  <div className='blog-arrow-position'><img src={blogBack} alt="back" /></div>
                  <div>{props.t("blog_full_back_button")}</div>
                </div>
              </Link>
              <div className="date-of-creation">
                {formatDate(postData._updatedAt)}
              </div>
            </div>
            <div className="blog-full-body-content-position">
              {b && (
                <BlockContent blocks={b.content} serializers={serializers} />
              )}
            </div>
            <div className="body-full-author">
              {/* {postData.author && (
                <div className='body-full-author-position'>                         if author needed
                  <div>{postData.author.name}</div>
                  {postData.author.image && (
                    <img
                      src={builder.image(postData.author.image.asset._ref).url()}
                      alt={'image3'}
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  )}
                </div>
              )} */}
            </div>
            <div className="other">
              <OtherArticles currentPageId={currentPageId} t={props.t}/>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default BlogFullVersion;




